import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HomeScreen } from "./screens/HomeScreen";
import { VisitRoute } from "./screens/VisitScreen";

/** Served under /app/ (nginx), which is also the service-worker scope. */
export function App() {
  return (
    <BrowserRouter basename="/app">
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/visit/:id" element={<VisitRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
